import React from "react";
import PortfolioBook from "./PortfolioBook.jsx";

function App() {
  return <PortfolioBook />;
}

export default App;
